const translations = {
  fr: {
    userProfile: {
      surname: 'Nom de famille',
      language: 'Langue',
      profileMenuItem: 'Mon profil',
      signOut: 'Déconnexion',
      update: 'Sauvegarder',
      edit: 'Modifier',
      fr: 'Français',
      en: 'English',
      nameEmptyMessage: 'Veuillez saisir votre prénom',
      surnameEmptyMessage: 'Veuillez saisir votre nom',
      languageEmptyMessage: 'Veuillez choisir votre language',
      languageInvalidMessage: 'Veuillez choisir un language parmi ceux offerts',
      missingCurrentPasswordMessage: 'Veuillez saisir votre mot de passe actuel',
      updatePassword: 'Modifier le mot de passe',
      oldPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      newPasswordVerification: 'Confirmer le nouveau mot de passe',
      updateProfileSuccess: 'Votre profil a été mis à jour',
      updateProfileError: 'Il y a eu une erreur lors de la mise à jour de votre profil',
      invalidEmailVerificationMessage: 'Vos courriels ne sont pas pareil',
      updateEmail: 'Modifier mon adresse courriel',
      newEmail: 'Nouvelle adresse courriel',
      newEmailVerification: 'Confirmer la nouvelle adresse courriel',
      updateEmailError: 'Il y a eu un problème lors de la mise à jour de votre courriel',
      updateEmailConfirmation: 'Un courriel vous a été envoyé',
      updateEmailSuccessful: 'Un courriel de confirmation a été envoyé à votre nouvelle adresse',
      updatePasswordError: 'Il y a eu une erreur lors de la modification de votre mot de passe',
      updatePasswordSuccessful: 'Votre mot de passe a été mis à jour',
      profile: 'Mon profil',
      generalInformations: 'Informations générales',
      confirmEmail: 'Confirmation de changement de courriel',
      confirmEmailSuccess: 'Votre adresse courriel a été modifiée',
      confirmEmailError: 'Il y a eu un problème lors de la confirmation de votre nouvelle adresse courriel',
      goToHome: "Aller vers l'accueil",
      emailAlreadyUse: 'Cette adresse couriel est déja utilisée',
    },
  },
  en: {
    userProfile: {
      surname: 'Surname',
      language: 'Language',
      profileMenuItem: 'My Profile',
      signOut: 'Sign Out',
      update: 'Update',
      edit: 'Edit',
      fr: 'Français',
      en: 'English',
      nameEmptyMessage: 'Please enter your name',
      surnameEmptyMessage: 'Please enter your surname',
      languageEmptyMessage: 'Please pick your language',
      languageInvalidMessage: 'Please pick a valid language',
      missingCurrentPasswordMessage: 'Please enter your current password',
      updatePassword: 'Edit my password',
      oldPassword: 'Current password',
      newPassword: 'New password',
      newPasswordVerification: 'New password verification',
      updateProfileSuccess: 'Your profile has been updated',
      updateProfileError: 'There was an error while updating your profile',
      invalidEmailVerificationMessage: "Your new email doesn't match the verification",
      updateEmail: 'Edit my email',
      newEmail: 'New email',
      newEmailVerification: 'New email verification',
      updateEmailError: 'There was an error while updating your email',
      updateEmailConfirmation: "We've sent you an email",
      updateEmailSuccessful: 'A confirmation email has been sent to your new email',
      updatePasswordError: 'There was en error while updating your password',
      updatePasswordSuccessful: 'Your password has been changed',
      profile: 'My Profile',
      generalInformations: 'General Informations',
      confirmEmail: 'Email change confirmation',
      confirmEmailSuccess: 'Your email has been changed',
      confirmEmailError: 'There was an error while confirming your new email',
      goToHome: 'Go to home page',
      emailAlreadyUse: 'This email is already use',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/userProfile/i18n/userProfile.js